/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Action_ExportInputs */

const cs_gdpr_action_export = /** @type {(inputs: Gdpr_Action_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const en_gdpr_action_export = /** @type {(inputs: Gdpr_Action_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exported`)
};

/**
* | output |
* | --- |
* | "Exported" |
*
* @param {Gdpr_Action_ExportInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_action_export = /** @type {((inputs?: Gdpr_Action_ExportInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Action_ExportInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_action_export(inputs)
	return cs_gdpr_action_export(inputs)
});